import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUserService } from '../../shared/services/api/user/api-user.service';
import { ResponseModuleState, computeResponseModuleState } from '../utils/response-module.utils';

@Injectable({ providedIn: 'root' })
export class ResponseModuleStateService {
  private readonly stateSubject = new ReplaySubject<ResponseModuleState | null>(1);
  readonly state$: Observable<ResponseModuleState | null> = this.stateSubject.asObservable();

  constructor(private apiUser: ApiUserService) {
    this.refresh();
  }

  refresh(): Observable<ResponseModuleState | null> {
    const obs = this.apiUser.getModules().pipe(map(modules => computeResponseModuleState(modules)));
    obs.subscribe(state => this.stateSubject.next(state));
    return obs;
  }
}
